import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import NewsCard from "@/components/base/NewsCard";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { news } from "@/mocks/news";

export default function NewsDetail() {
  const { id } = useParams();
  const item = news.find((n) => n.id === id);

  useDocumentTitle(
    item ? `${item.title} - 杨幂动态` : "新闻不存在 - 杨幂动态",
    item ? item.summary : "新闻内容不存在",
    item ? `杨幂动态,${item.category},杨幂新闻` : "杨幂动态",
  );

  if (!item) {
    return (
      <div className="w-full px-4 md:px-8 py-20 flex flex-col items-center text-center">
        <span className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center text-foreground-400 mb-4">
          <i className="ri-error-warning-line text-3xl" />
        </span>
        <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">新闻内容不存在</h1>
        <p className="mt-2 text-sm text-foreground-500">未找到对应的资讯内容，可能链接有误。</p>
        <Link
          to="/news"
          className="mt-6 inline-flex items-center gap-2 px-5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors"
        >
          返回资讯动态
        </Link>
      </div>
    );
  }

  const related = news.filter((n) => n.id !== item.id && n.category === item.category).slice(0, 3);
  const fallback = news.filter((n) => n.id !== item.id).slice(0, 3);
  const relatedList = related.length > 0 ? related : fallback;

  return (
    <div className="w-full px-4 md:px-8 py-8 md:py-12">
      <Breadcrumb
        items={[{ label: "首页", path: "/" }, { label: "资讯动态", path: "/news" }, { label: item.category }]}
      />

      <article className="mt-6 max-w-3xl mx-auto">
        <div className="flex items-center gap-3 flex-wrap mb-4">
          <Link
            to="/news"
            className="px-2.5 py-1 rounded-md text-xs font-label bg-accent-100 text-accent-900 hover:bg-accent-200 transition-colors"
          >
            {item.category}
          </Link>
          <span className="text-xs text-foreground-400">{item.date}</span>
          <span className="text-xs text-foreground-400">来源：{item.author}</span>
        </div>

        <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">{item.title}</h1>

        <div className="mt-6 w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-100 border border-background-200">
          <img
            src={item.cover}
            alt={`${item.title}配图`}
            title={`${item.title} - 杨幂动态`}
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="mt-8 space-y-5">
          {item.content.map((p, idx) => (
            <p key={idx} className="text-sm md:text-base text-foreground-700 leading-loose">
              {p}
            </p>
          ))}
        </div>
      </article>

      {relatedList.length > 0 && (
        <section className="mt-16 max-w-4xl mx-auto">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-6">相关推荐</h2>
          <div className="flex flex-col gap-4 md:gap-5">
            {relatedList.map((n) => (
              <NewsCard key={n.id} item={n} />
            ))}
          </div>
        </section>
      )}
    </div>
  );
}